
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/reader/[alias]",
      function () {
        return require("private-next-pages/reader/[alias]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/reader/[alias]"])
      });
    }
  